<template>
  <v-row
    no-gutters
    class="align-center element justify-space-between flex-nowrap"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
    @click="hideableGroups && isGroup ? $emit('toggleHideGroup') : null"
  >
    <v-col v-if="hasDragHandler" cols="auto" :class="{ 'pl-1': isGroup }" style="min-width: 28px">
      <v-tooltip
        top
        color="font"
        :disabled="pinned || (!computedDisableDraggable && !itemTooltips.dragItem && !itemTooltips.dragGroup)"
      >
        <template #activator="{ on }">
          <v-icon
            v-on="on"
            :class="{ handle: !pinned }"
            :style="computedDisableDraggable ? 'cursor: not-allowed' : 'cursor: grab'"
            :color="isVisible ? '' : $_colors.disabled"
            :size="pinned ? 20 : 24"
          >
            {{ pinned ? 'mdi-pin' : 'mdi-drag' }}
          </v-icon>
        </template>
        {{
          computedDisableDraggable
            ? $i18n.t('admin.customMenus.draggingDisabledWhenFiltered')
            : isGroup
              ? itemTooltips.dragGroup
              : itemTooltips.dragItem
        }}
      </v-tooltip>
    </v-col>
    <v-col v-if="hideableGroups && isGroup" cols="auto">
      <v-icon :color="isVisible ? '' : $_colors.disabled">
        {{ isHidden ? 'mdi-menu-right' : 'mdi-menu-down' }}
      </v-icon>
    </v-col>
    <v-col style="min-width: 0" :class="{ 'pl-4': isGroup && !hideableGroups }">
      <v-row no-gutters class="flex-nowrap align-center px-1">
        <v-col cols="auto">
          <slot
            name="item.prepend-title"
            :item="{ ...$attrs, ...$props }"
            :disabled="disabled"
            :visible="isVisible"
          ></slot>
        </v-col>
        <v-col cols="auto" class="flex-shrink-1" style="min-width: 0">
          <v-tooltip top color="font" :disabled="isGroup || (!tooltip && !itemTooltips.itemTitle)">
            <template #activator="{ on }">
              <div
                ref="title-item"
                v-on="on"
                class="text-truncate text-body-2"
                :class="{ 'pl-2': level > 1, 'text--disabled': disabled || !isVisible }"
                style="padding-top: 2px"
              >
                {{ title }}
              </div>
            </template>
            {{ tooltip || itemTooltips.itemTitle }}
          </v-tooltip>
        </v-col>
        <v-col cols="auto">
          <slot
            name="item.append-title"
            :item="{ ...$attrs, ...$props }"
            :disabled="disabled"
            :visible="isVisible"
          ></slot>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <slot
            name="item.postappend-title"
            :item="{ ...$attrs, ...$props }"
            :disabled="disabled"
            :visible="isVisible"
          ></slot>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="auto" @click.stop>
      <dots-menu
        v-if="dotsItems && dotsItems.length"
        :disabled="disabled"
        font-size="19px"
        :items="dotsItems"
        v-on="getListeners()"
        :color="isVisible ? '' : $_colors.disabled"
      />
    </v-col>
  </v-row>
</template>
<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'DraggableListItem',
  components: { DotsMenu },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hideableGroups: {
      type: Boolean,
      default: false,
    },
    dotsItems: {
      type: Array,
    },
    childItemsKey: {
      type: String,
      default: 'items',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: null,
    },
    level: {
      type: Number,
      default: 1,
    },
    titleKey: {
      type: String,
      default: 'name',
    },
    isHidden: {
      type: Boolean,
      default: false,
    },
    disableBorders: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Object,
    },
    disableDraggable: {
      type: Boolean,
      default: false,
    },
    hasDragHandler: {
      type: Boolean,
      default: false,
    },
    itemTooltips: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pinned: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedDisableDraggable() {
      return this.disableDraggable || this.pinned;
    },
    isGroup() {
      return this.$attrs[this.childItemsKey] ? true : false;
    },
    classes() {
      return this.level > 1
        ? [...(this.isGroup ? [] : [...(this.disableBorders ? [] : ['border']), 'px-4'])]
        : this.isGroup
          ? [this.isHidden ? 'hidden' : '']
          : ['px-6'];
    },
    backgroundColor() {
      return this.isGroup ? '' : 'rgb(231, 231, 231, 0.5)';
    },
    title() {
      return this.$attrs[this.titleKey];
    },
    isVisible() {
      return Object.keys(this.$attrs).includes('visible')
        ? this.$attrs.visible
        : this.isGroup
          ? this.$attrs[this.childItemsKey].some(childItem =>
              Object.keys(childItem).includes('visible') && childItem['visible'] === false ? false : true
            )
          : true;
    },
  },
  methods: {
    getListeners() {
      return Object.keys(this.$listeners).reduce((total, key) => {
        return {
          ...total,
          [key]: () => {
            this.$emit(key, { ...this.$props, ...this.$attrs });
          },
        };
      }, {});
    },
  },
};
</script>
<style scoped lang="scss">
.element {
  height: 40px;
}
.border {
  margin-bottom: 4px;
  @include border(right);
  @include border(left);
  @include border(bottom);
  &:first-child {
    @include border(top);
  }
}
</style>
